{
  "hotkeys": {
    "Space": "turbo"
  },
  "directions": {
    "Up": ["ArrowUp", "KeyW"],
    "Down": ["ArrowDown", "KeyS"],
    "Left": ["ArrowLeft", "KeyA"],
    "Right": ["ArrowRight", "KeyD"]
  },
  "consoles": {
    "gb": {
      "moves": "D-pad",
      "buttons": [
        { "button": "A", "keys": ["KeyX", "Slash"] },
        { "button": "B", "keys": ["KeyZ", "Period"] },
        { "button": "L", "keys": ["KeyQ"] },
        { "button": "R", "keys": ["KeyE"] },
        { "button": "Start", "keys": ["Enter"] },
        { "button": "Select", "keys": ["Backspace"] }
      ]
    },
    "n64": {
      "moves": "analog stick",
      "buttons": [
        { "button": "A", "keys": ["KeyX", "Slash"] },
        { "button": "B", "keys": ["KeyZ", "Period"] },
        { "button": "Z trigger", "keys": ["KeyC", "Comma"] },
        { "button": "C up", "keys": ["KeyI"] },
        { "button": "C left", "keys": ["KeyJ"] },
        { "button": "C down", "keys": ["KeyK"] },
        { "button": "C right", "keys": ["KeyL"] },
        { "button": "D-pad up", "keys": ["KeyT"] },
        { "button": "D-pad left", "keys": ["KeyF"] },
        { "button": "D-pad down", "keys": ["KeyG"] },
        { "button": "D-pad right", "keys": ["KeyH"] },
        { "button": "L", "keys": ["KeyQ"] },
        { "button": "R", "keys": ["KeyE"] },
        { "button": "Start", "keys": ["Enter"] }
      ]
    },
    "psx": {
      "moves": "D-pad",
      "buttons": [
        { "button": "Cross", "keys": ["KeyX", "Slash", "KeyK"] },
        { "button": "Circle", "keys": ["KeyZ", "Period", "KeyL"] },
        { "button": "Square", "keys": ["KeyC", "Comma", "KeyJ"] },
        { "button": "Triangle", "keys": ["KeyV", "KeyI"] },
        { "button": "L1", "keys": ["KeyQ"] },
        { "button": "R1", "keys": ["KeyE"] },
        { "button": "L2", "keys": ["Digit1"] },
        { "button": "R2", "keys": ["Digit3"] },
        { "button": "Start", "keys": ["Enter"] },
        { "button": "Select", "keys": ["Backspace"] }
      ]
    },
    "psp": {
      "moves": "D-pad",
      "buttons": [
        { "button": "Cross", "keys": ["KeyX", "Slash", "KeyK"] },
        { "button": "Circle", "keys": ["KeyZ", "Period", "KeyL"] },
        { "button": "Square", "keys": ["KeyC", "Comma", "KeyJ"] },
        { "button": "Triangle", "keys": ["KeyV", "KeyI"] },
        { "button": "L", "keys": ["KeyQ"] },
        { "button": "R", "keys": ["KeyE"] },
        { "button": "Start", "keys": ["Enter"] },
        { "button": "Select", "keys": ["Backspace"] }
      ]
    }
  }
}
